import { Box, Paper, Slider, Tooltip, useMediaQuery } from '@mui/material';
import { AudioModule } from 'components-new/common/AudioModule';
import { useEffect, useState } from 'react';
import { emitter, MittEvents } from '../../../../events';

const audioHandler = AudioModule.getInstance();

type Props = {
  mute: boolean;
  setMute: (v: boolean) => void;
};

export const TourVolume = ({ mute, setMute }: Props) => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const [volume, setVolume] = useState(audioHandler.getVolume() || 1);

  useEffect(() => {
    emitter.on(MittEvents.AUDIO_VOLUME, (e) => {
      const v = e.volumeValue;
      if (Number(v)) {
        setVolume(Number(v));
      }
    });
    emitter.on(MittEvents.AUDIO_MUTE, (e) => {
      const m = e.mute;
      setMute(m);
    });

    // Clean up on unmount
    return () => {
      emitter.off(MittEvents.AUDIO_VOLUME);
      emitter.off(MittEvents.AUDIO_MUTE);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    audioHandler.volumeHandler(volume);
  }, [volume]);

  useEffect(() => {
    audioHandler.volumeHandler(mute ? 0 : volume);
    emitter.emit(MittEvents.AUDIO_MUTE, { mute });
  }, [mute, volume]);

  const volumeIcon = volume < 0.5 ? 'fa-volume-low' : 'fa-volume';

  return (
    <Box className="data-balloon" mb={1}>
      <Tooltip
        enterDelay={isMobile ? 50 : 250}
        leaveDelay={isMobile ? 1000 : 300}
        placement="top"
        arrow={false}
        components={{
          Tooltip: Paper,
        }}
        componentsProps={{
          tooltip: {
            sx: {
              background: 'rgba(0,0,0,0.5)',
              paddingY: 2,
              borderRadius: '50px',
              marginBottom: '10px',
            },
          },
        }}
        title={
          <Slider
            sx={{
              height: '120px',
              color: 'white',

              '& .MuiSlider-thumb:hover': {
                boxShadow: '0px 0px 0px 6px rgba(255, 255, 255, 0.5)',
              },
            }}
            orientation="vertical"
            value={volume * 100}
            onChange={(e, value) => {
              if (Number(value)) {
                setVolume(Number(value) / 100);
                setMute(false);
              }
            }}
            min={0}
            max={100}
          />
        }
      >
        <button className="actions-btn btn" onClick={() => setMute(!mute)}>
          <i className={`fas ${mute ? 'fa-volume-slash' : volumeIcon}`} />
        </button>
      </Tooltip>
    </Box>
  );
};
